/**
 * Appends REQUEST async action type
 */

const REQUEST = actionType => `${actionType}_PENDING`;

/**
 * Appends SUCCESS async action type
 */

const SUCCESS = actionType => `${actionType}_FULFILLED`;

/**
 * Appends FAILURE async action type
 */

const FAILURE = actionType => `${actionType}_REJECTED`;

const SOCKET = eventName => `${eventName}_SOCKET`;

const SOCKET_LOG_INFO = eventName => `${eventName}_SOCKET_LOG_INFO`;

const QUERY_CHANGE = 'QUERY_CHANGED';

module.exports = {
  REQUEST,
  SUCCESS,
  FAILURE,
  SOCKET,
  SOCKET_LOG_INFO,
  QUERY_CHANGE,
};
